export const openPopUp = (content) => ({
    type: 'OPEN_POPUP',
    content
});

export const closePopUp = () => ({
    type: 'CLOSE_POPUP'
})